export default "__VITE_ASSET__BBJMxfeS__"